<template>
  <div
    class="child-list-content flex flex-col"
    :class="{
      'empty-group': isEmptyGroup,
    }"
  >
    <div class="child-list-header border-0 border-b border-solid border-standard-bg w-full">
      <BoardListHeader
        :list-id="props.listId"
        :header-footer-style="{}"
        :expandable="true"
        :show-status-icon-picker="showStatusIconPickerSubGroup"
        :disable-status-icon-picker="true"
        :group-by="boardSubGroupBy"
        :list-cards="listCards"
        :visible="true"
        :is-cards-layout-timeline="false"
        :is-epic-board="false"
      />
    </div>
    <div
      v-if="listExpanded"
      class="child-lists flex"
    >
      <div
        v-for="(parentList, index) in props.mainListIds"
        :key="index"
        class="child-list-cards flex flex-col overflow-auto"
        :class="{
          'empty-group': isMainListEmpty(parentList),
        }"
      >
        <BoardList
          :ref="`boardList-${props.listId}`"
          :visible="true"
          :list-id="props.listId"
          :parent-list-id="parentList"
          :index="index"
          :large-board="false"
          :max-displayed-lists="maxDisplayedLists"
          :expandable="true"
          :position="position"
          :container-width="containerWidth"
          :sprint-disable-drag="true"
          :show-add-card-button="true"
          :show-list-header="false"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import useSwimlanes from '../../boards/composables/useSwimlanes';
import BoardListHeader from '@/components/widgets/BoardListHeader.vue';
import BoardList from '@/components/widgets/BoardList.vue';

const {
  boardSubGroupBy,
  showStatusIconPickerSubGroup,
  currentBoardId,
  subGroupByObject,
  hideEmptyGroups,
} = useSwimlanes();

const store = useStore();

const props = defineProps({
  listId: {
    type: String,
    required: true,
  },
  mainListIds: {
    type: Array,
    required: true,
  },
  maxDisplayedLists: {
    type: Number,
    default: 4,
  },
  position: {
    type: Number,
    required: false,
    default: 0,
  },
  containerWidth: {
    type: Number,
    required: false,
    default: 0,
  },
  emptyMainLists: {
    type: Array,
    required: false,
    default: () => [],
  },
});

const listExpanded = computed(() => {
  return store.getters.getListExpanded(currentBoardId.value, props.listId);
});

const listCards = computed(() => {
  const listCards: string[] = [];
  for (const mainListId of props.mainListIds) {
    const listId = mainListId as string | number;
    const propListId = props.listId;
    if (subGroupByObject.value?.[listId] && subGroupByObject.value[listId]?.[propListId]?.cardIds) {
      listCards.push(...(subGroupByObject.value[listId]?.[propListId]?.cardIds || []));
    }
  }
  return listCards;
});

// Check if main list is in the emptyMainLists array
const isMainListEmpty = (mainListId: unknown) => {
  return props.emptyMainLists.includes(String(mainListId));
};

const isEmptyGroup = computed(() => {
  return hideEmptyGroups.value && !listCards.value.length;
});
</script>

<style lang="scss">
.child-list-content {
  &.empty-group {
    flex-basis: 0 !important;
    min-height: 0;
    > * {
      display: none;
    }
  }
}
</style>
